import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { CATEGORIES } from "@/lib/mockData";

export default function FocusAreaCard({ data, index = 0 }) {
    const cat = CATEGORIES[data.category];
    const Icon = cat.icon;

    return (
        <motion.article
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{
                duration: 0.85,
                ease: [0.22, 1, 0.36, 1],
                delay: index * 0.08,
            }}
            whileHover={{ y: -8 }}
            data-testid={`focus-area-${cat.key}`}
            className={`relative overflow-hidden rounded-3xl border ${cat.tintBorder} ${cat.tintBg} group`}
        >
            <div className="absolute inset-0 grain pointer-events-none opacity-50" />
            <div className={`relative aspect-[16/10] overflow-hidden ${cat.tintBg}`}>
                <img
                    src={data.image}
                    alt={cat.label}
                    className={`w-full h-full ${data.imageClass ?? "object-cover"} transition-transform duration-1000 ${data.imageHoverClass ?? "group-hover:scale-110"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-seedh-text/60 via-transparent to-transparent" />
                <div className="absolute top-5 left-5 inline-flex items-center gap-2 rounded-full bg-white/95 backdrop-blur px-3.5 py-1.5">
                    <Icon className={`w-3.5 h-3.5 ${cat.accentText}`} />
                    <span className={`text-[0.7rem] tracking-[0.18em] uppercase font-semibold ${cat.accentText}`}>
                        {cat.label}
                    </span>
                </div>
            </div>

            <div className="p-7 md:p-8">
                <p className="text-base text-seedh-text leading-relaxed">
                    {data.description}
                </p>

                <div className="mt-6 space-y-3">
                    <div className="flex items-center gap-3 text-sm">
                        <span className={`w-7 h-7 rounded-full bg-white border ${cat.tintBorder} flex items-center justify-center`}>
                            <span className={`w-1.5 h-1.5 rounded-full ${cat.accentBg}`} />
                        </span>
                        <span className="text-seedh-text font-medium">{data.example}</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm">
                        <span className={`w-7 h-7 rounded-full bg-white border ${cat.tintBorder} flex items-center justify-center`}>
                            <MapPin className={`w-3.5 h-3.5 ${cat.accentText}`} />
                        </span>
                        <span className="text-seedh-muted">{data.tracking}</span>
                    </div>
                </div>

                <Link
                    to={`/donate?cause=${cat.key}`}
                    data-testid={`focus-area-cta-${cat.key}`}
                    className={`mt-7 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white ${cat.accentBg} transition-transform hover:-translate-y-0.5`}
                >
                    {data.cta}
                    <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
        </motion.article>
    );
}
